import { types } from 'mobx-state-tree';
import { stateModelFactory as baseModelFactory } from '@jbrowse/core/BaseFeatureWidget';
export function stateModelFactory(pluginManager) {
    const baseModel = baseModelFactory(pluginManager);
    return types.compose(baseModel, types.model('AlignmentsFeatureWidget', {
        type: types.literal('AlignmentsFeatureWidget'),
    }));
}
